import React from 'react';

import {useFile} from 'pageflow-scrolled/frontend';
import {DefaultNavigation} from 'pageflow-scrolled/widgets/defaultNavigation';

import 'pageflow-scrolled/widgets/defaultNavigation.css';

import noenLogo from './images/noen.svg';
import bvzLogo from './images/bvz.svg';

import styles from './Navigation.module.css';

export function NoenNavigation(props) {
  return <Navigation Logo={NoenLogo} {...props} />;
}

export function BvzNavigation(props) {
  return <Navigation Logo={BvzLogo} {...props} />;
}

export function Navigation(props) {
  const configuration = props.configuration;

  const sponsorLogoDesktop = useFile({
    permaId: configuration.sponsorLogoDesktop,
    collectionName: 'imageFiles'
  });

  const sponsorLogoMobile = useFile({
    permaId: configuration.sponsorLogoMobile,
    collectionName: 'imageFiles'
  });

  return (
    <DefaultNavigation {...props}
                       logo={{
                         srcDesktop: sponsorLogoDesktop && imageUrl(sponsorLogoDesktop),
                         srcMobile: sponsorLogoMobile && imageUrl(sponsorLogoMobile),
                         url: configuration.sponsorLogoUrl,
                         altText: sponsorLogoDesktop?.configuration?.alt
                       }}
                       ExtraButtons={sponsorLogoDesktop && props.Logo} />
  );
}

function imageUrl(imageFile) {
  if (imageFile.extension.toLowerCase() === 'svg') {
    return imageFile.urls.original;
  }
  else {
    return imageFile.urls.print
  }
}

export function NoenLogo() {
  return (
    <a target="_blank"
       rel="noopener noreferrer"
       href="https://www.noen.at"
       className={styles.logo}>
      <img src={noenLogo}
           alt="NÖN" />
    </a>
  );
}

export function BvzLogo() {
  return (
    <a target="_blank"
       rel="noopener noreferrer"
       href="https://www.bvz.at"
       className={styles.logo}>
      <img src={bvzLogo}
           alt="BVZ" />
    </a>
  );
}
